var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.559 468.312C152.059 475.813 144.09 480 135.934 480C131.778 480 127.559 478.906 123.716 476.625C118.685 473.625 0 401.312 0 255.998S118.685 38.372 123.716 35.372C135.153 28.591 149.84 32.372 156.621 43.716C163.402 55.091 159.652 69.81 148.278 76.622C143.653 79.435 47.999 138.873 47.999 255.998C47.999 373.499 144.246 432.937 148.34 435.406C159.652 442.25 163.34 456.969 156.559 468.312Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketRound);
export default __webpack_public_path__ + "static/media/bracket-round.11517b1fe58ccd5db81f7d6f2a613b80.svg";
export { ForwardRef as ReactComponent };